document.addEventListener("DOMContentLoaded", function () {

    let video = document.querySelector("#scroll-video");
    let header = document.querySelector("#storeheader");

    video.pause();
    video.currentTime = 0;

    video.onloadedmetadata = function () {
        let videoDuration = video.duration;
        let headerHeight = header.offsetHeight;

        gsap.timeline({
            scrollTrigger: {
                trigger: ".video-container",
                start: () => "top top",
                end: "+=" + window.innerHeight * 2, // Adjust for full playback
                scrub: 0,
                pin: true, // Keeps video fixed until playback is done
                markers: false,
                onUpdate: (self) => {
                      // Use requestAnimationFrame to prevent dropped frames
                      requestAnimationFrame(() => {
                          video.currentTime = videoDuration * self.progress;
                      });
                }
            }
        }).to(video, {
            currentTime: videoDuration, // Syncs video playback with scrolling
            ease: "none"
        });
    };
});
